import { TitleType } from './types';

interface ISecTitleProps {
  title: TitleType;
  titleStyle: React.CSSProperties;
}

export default function SecondaryTitle({ title, titleStyle }: ISecTitleProps) {
  return (
    <div style={titleStyle}>
      <div className="mr-5">
        {title.titleIcon && <title.titleIcon />}
      </div>
      {title.titleText}
    </div>
  );
}
